import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FuseVerticalNavigationComponent } from '../../../../../@fuse/components/navigation';
import { FuseFullscreenComponent } from '../../../../../@fuse/components/fullscreen';
import { SearchModule } from '../../../common/search/search.module';
import { ClassyLayoutComponent } from './classy.component';
import { CommonModule } from '@angular/common';

@NgModule({ declarations: [
        ClassyLayoutComponent
    ],
    exports: [
        ClassyLayoutComponent
    ], imports: [CommonModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        FuseFullscreenComponent,
        FuseVerticalNavigationComponent,
        SearchModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class ClassyLayoutModule {
}
